import { injectIntl, InjectedIntlProps } from "react-intl"
import * as React from "react"
import * as Utils from "./utils"
import { bodyW } from "../../pptx-configuration/constants"
import * as CommonUtils from "../../utils"
import * as Conf from "../../../configuration"

class OperationProgressTable
extends React.Component<Props & InjectedIntlProps, State> {
	private readonly columns: Column[]
	private readonly labelCellWidth: number
	private readonly numberCellWidth: number
	private readonly yearCellWidth: number

	constructor(props: Readonly<Props & InjectedIntlProps>) {
		super(props)        
		this.columns = createColumns(props.years)
		this.labelCellWidth = CommonUtils.toInches(3)
		this.numberCellWidth = CommonUtils.toInches(0.7)
		const remainingSpace = bodyW - this.numberCellWidth - this.labelCellWidth

		/** Nombre de cellules d'années */
		const yearCellsCount = (this.columns.length + 6) / 2
		// 2/3 de l'espace restant
		this.yearCellWidth = (remainingSpace * 2 / 3) / yearCellsCount
	}

	render() {
		const data = this.props.data
		const tableConf = this.props.tableConfiguration
		const columns = this.columns
        const referenceYear = this.props.referenceYear.toString() + "-" + (this.props.referenceYear - 1).toString();		

		return <table id={this.props.id}>
			{/* En-tête */}
			<thead>
				<tr>
					<th data-pptx-width={this.labelCellWidth}
					style={{ ...tableConf.header }}>Numéro comptes</th>

					<th data-pptx-width={this.labelCellWidth}
					style={{ ...tableConf.header }}>Articles</th>

					{columns.map((column, colIndex) => {
						return <th
						data-pptx-width={this.yearCellWidth}
						key={colIndex}
						style={{ ...tableConf.header }}>
							{column}
						</th>
					})}

                    <th data-pptx-width={this.yearCellWidth}
					style={{ ...tableConf.header }}>Var. {referenceYear}</th>

                    <th data-pptx-width={this.yearCellWidth}
					style={{ ...tableConf.header }}>Var. % ({referenceYear})</th>

				</tr>
			</thead>

			<tbody>
			{data.map((row, rowIndex) => (
				row.accounts.map((rowAccount, rowAccountIndex) => (
					<tr key={`${rowIndex}-${rowAccountIndex}`}>
					  <td style={{ ...tableConf.common, color: 'inherit' }}>
						{rowAccount.account.number}
					  </td>
					  <td style={{ ...tableConf.common, color: 'inherit' }}>
						{rowAccount.account.label}
					  </td>
					  {/* Afficher les valeurs par années */}
					  {Object.keys(rowAccount.values).map((year, rowValueIndex) => {
						const isLastColumn = rowValueIndex === Object.keys(rowAccount.values).length - 1;
						return (
							<td
							key={`${rowIndex}-${rowAccountIndex}-${year}`}
							style={{
								...tableConf.common,
								...tableConf.numeric,
								color: isLastColumn ? this.getRowColor(rowAccount.values) : 'inherit',
							}}
							>
							{this.getValeurYear(rowAccount.values[year])}
							</td>
						);
					  })}
					  <td style={{ ...tableConf.common, ...tableConf.numeric, color: this.getRowColor(rowAccount.values) }}>
						{this.getVariationRender(rowAccount.values)}
					  </td>
					</tr>
				  ))
    		))}
			</tbody>

		</table>
	}

	getRowColor(values: any){
		const variationPercentage = this.getVariation(values) * 100;
		return this.props.receipts 
		? (variationPercentage > 0 ? "green" : "red")
		: (variationPercentage > 0 ? "red" : "green");
	}

	getValeurYear(value: any) {
		return CommonUtils.formatCurrency(
			this.props.locale, this.props.currency, value, this.props.roundness)
	}

	getVariationRender(values: any) {
		const variationPercentage = this.getVariation(values);
		const displayValue = this.props.intl
			.formatNumber(variationPercentage, { style: "percent" })
		return `${variationPercentage > 0 ? "+" : ""}${displayValue}`;
	}


	getVariation(values: any){
		const referenceYear = this.props.referenceYear.toString();
		const previousYear =  (this.props.referenceYear - 1).toString();

		const valueReference = values[referenceYear] || 0; // Utiliser 0 si pas de valeur
		const valuePrevious = values[previousYear] || 0; // Utiliser 0 si pas de valeur
	
		// Calculer la variation en %
		if (valuePrevious === 0) {
			return valueReference > 0 ? 100 : 0; // Évite la division par zéro
		}
	
		const variationPercentage = ((valueReference - valuePrevious) / valuePrevious);
		return variationPercentage;
	}

}

export default injectIntl(OperationProgressTable)

export interface Props {
	currency: string
	data: Utils.ProgressData[]
	id: string
	locale: string
	roundness: Conf.RoundnessValue
	tableConfiguration: Conf.TableConfiguration
	years: number[]
    referenceYear: number
	receipts: boolean
}

function createColumns(years: number[]): Column[] {
	return years.reduce<Column[]>((columns, year, yearIndex) => {
		columns.push(year)
		return columns
	}, [])
}

interface State {}

type CellType = "subtotal" | "total"
type Column = number | string



// WEBPACK FOOTER //
// ./src/component/management-report/generator/observation-generator/operation-generator/operation-progress-table.tsx